
import React from 'react';
import { Cpu, ShieldCheck, Database, Zap, Lock, RefreshCw } from 'lucide-react';

const Technology: React.FC = () => {
  return (
    <div className="pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <header className="mb-24 text-center">
          <h1 className="text-5xl font-bold text-slate-900 font-heading mb-6">L'Innovation comme moteur de performance.</h1>
          <div className="w-24 h-1 bg-prime-blue mx-auto"></div>
        </header>

        {/* AI Section */}
        <section className="mb-32">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
             <div className="order-2 lg:order-1 relative">
                <div className="bg-prime-dark rounded-3xl p-1 border border-slate-800 overflow-hidden shadow-2xl shadow-prime-blue/10">
                  <div className="bg-slate-950 p-8 rounded-[1.4rem]">
                    <div className="flex items-center space-x-3 mb-8">
                      <div className="w-3 h-3 rounded-full bg-prime-blue"></div>
                      <span className="text-xs font-bold text-slate-400 uppercase tracking-widest">Augmented Intelligence Engine v3.1</span>
                    </div>
                    
                    <div className="space-y-4">
                      <div className="p-4 bg-slate-900/50 rounded-xl border border-slate-800 text-sm font-mono text-prime-blue">
                        Analyzing sentiment in real-time... <br/>
                        Confidence: 98.4% <br/>
                        Suggestion: Empathetic resolution path B.
                      </div>
                      <div className="flex justify-end">
                        <div className="p-4 bg-prime-blue rounded-xl rounded-tr-none text-sm font-medium max-w-[80%] text-white">
                          "Je comprends parfaitement votre situation. Voici ce que nous allons faire immédiatement pour régler cela."
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="absolute -top-6 -right-6 bg-white border border-sand-200 p-4 rounded-2xl shadow-xl animate-float">
                  <Cpu className="text-prime-blue w-8 h-8" />
                </div>
             </div>

             <div className="order-1 lg:order-2 space-y-6">
                <h2 className="text-3xl font-bold text-slate-900 font-heading">L'Augmented Agent.</h2>
                <p className="text-xl text-slate-600 leading-relaxed font-medium">
                  Nous ne remplaçons pas l'humain, nous l'augmentons. Nos conseillers disposent d'outils de travail qui les rendent plus performants, réduisant le temps de traitement et augmentant la pertinence.
                </p>
                <div className="grid sm:grid-cols-2 gap-6 pt-6">
                   <div className="space-y-3">
                      <div className="text-prime-blue"><Zap size={24} /></div>
                      <h4 className="text-slate-900 font-bold">Analyse de sentiment</h4>
                      <p className="text-slate-500 text-sm font-medium">Aide l'agent à ajuster son ton en temps réel pour une empathie maximale.</p>
                   </div>
                   <div className="space-y-3">
                      <div className="text-prime-blue"><Database size={24} /></div>
                      <h4 className="text-slate-900 font-bold">Knowledge Base IA</h4>
                      <p className="text-slate-500 text-sm font-medium">Extraction instantanée des informations pour réduire le temps d'attente.</p>
                   </div>
                </div>
             </div>
          </div>
        </section>

        {/* Security Section */}
        <section className="bg-prime-dark rounded-[3rem] p-12 lg:p-20 border border-white/5 relative overflow-hidden shadow-2xl">
           <div className="absolute top-0 right-0 p-20 opacity-5 text-white">
              <ShieldCheck size={300} />
           </div>
           
           <div className="max-w-3xl relative z-10">
              <h2 className="text-3xl md:text-4xl font-bold text-white font-heading mb-8">Vos données sont en forteresse.</h2>
              <p className="text-xl text-sand-100/60 mb-12 leading-relaxed">
                Conformité RGPD stricte, infrastructure redondante, PCA (Plan de Continuité d'Activité). Dormez tranquille, nous assurons la garde 24/7/365.
              </p>
              
              <div className="grid md:grid-cols-3 gap-8">
                 <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 rounded-xl bg-white/5 flex items-center justify-center text-prime-blue border border-white/10">
                      <Lock size={20} />
                    </div>
                    <div>
                      <h4 className="text-white font-bold text-sm">Chiffrement AES-256</h4>
                    </div>
                 </div>
                 <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 rounded-xl bg-white/5 flex items-center justify-center text-prime-blue border border-white/10">
                      <ShieldCheck size={20} />
                    </div>
                    <div>
                      <h4 className="text-white font-bold text-sm">Certifié RGPD</h4>
                    </div>
                 </div>
                 <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 rounded-xl bg-white/5 flex items-center justify-center text-prime-blue border border-white/10">
                      <RefreshCw size={20} />
                    </div>
                    <div>
                      <h4 className="text-white font-bold text-sm">Disponibilité 99.9%</h4>
                    </div>
                 </div>
              </div>
           </div>
        </section>
      </div>
    </div>
  );
};

export default Technology;
